import _, { get, set } from 'lodash';
import { ajaxApi,ajaxApiGet } from '@/server/index'
import { getCookie } from '@/public/utils'
import common from "@/public/common";


var apiHost =  common.SapUrl
// var apiHost = 'http://192.168.10.67:8120/' || common.SapUrl
const otherAdminName = getCookie('otheradminName') ? JSON.parse(getCookie('otheradminName')) : {}






// 查询缓存数据（from list）
export const  fetchTempApi= (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/get-cached-zd`,
        params
    }, 'data')
}

// 匹配单状态变更
export const  fetchDetail= (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/query-match-detail`,
        params
    }, 'data')
}

export const  queryBillByRange= (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/update-status`,
        params
    }, 'data')
}


// 匹配单创建-发票列表查询
export const  fetchInvoices= (params = {}) => {
    return ajaxApi({
        url: `${apiHost}/invoice/invoice-match/query-invoice-page-list`,
        params
    }, 'data')
}

export const  createInvoiceMatch= (params = {}) => {
    return ajaxApi({
        url: `${apiHost}invoice/invoice-match/create`,
        params
    }, 'data')
}

//查询快递公司
export const  fetchExpressCompany= (params = {}) => {
    return ajaxApiGet({
        url: `${common.SapUrl}document/express`,
        params
    }, 'data')
}


// WEBPACK FOOTER //
// ./src/pages/billVerification/match/detail/api.js